import { Card, CardContent, Grid, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import StatCard, { StatCardProps } from "../star-card";
import OrderCard from "./order-card";

const colorPalette = ["#1976d2"];

interface Props {
  labels: string[];
  orders: number[];
  headerData: StatCardProps[];
  /** Tiêu đề phụ cho biểu đồ (khoảng thời gian đang xem). */
  chartTitle?: string;
}

const OrdersStatisticalView = ({
  labels,
  orders,
  headerData,
  chartTitle,
}: Props) => {
  return (
    <div>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Đơn hàng
      </Typography>
      {chartTitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {chartTitle}
        </Typography>
      )}

      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {headerData?.map((card: any, index) => (
          <Grid key={index} item xs={12} sm={6} lg={3}>
            <OrderCard {...card} />
          </Grid>
        ))}
      </Grid>

      <Card variant="outlined" sx={{ width: "100%" }}>
        <CardContent>
          <BarChart
            colors={colorPalette}
            xAxis={[
              {
                scaleType: "band",
                data: labels ?? [],
              },
            ]}
            series={[
              {
                id: "orders",
                label: "Đơn hàng",
                data: orders?.map((v) => v ?? 0) ?? [],
                stack: "A",
              },
            ]}
            height={350}
            margin={{ left: 0, right: 0, top: 20, bottom: 20 }}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default OrdersStatisticalView;